import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSparkle3"><Path d="M15.9229 8.07617L22 10.4131V13.5869L15.9229 15.9229L13.5869 22H10.4131L8.07617 15.9229L2 13.5869V10.4131L8.07617 8.07617L10.4131 2H13.5869L15.9229 8.07617Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSparkle3;
